export default "__VITE_ASSET__D0w5dV$g__"